var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxCloudUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66927 12.666V9.99935H10.6693L8.0026 6.66602L5.33594 9.99935H7.33594V12.666H8.66927Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66927 12.6673H6.0026V11.334H4.66927C3.5666 11.334 2.66927 10.4367 2.66927 9.33398C2.66927 8.39798 3.4686 7.49665 4.45127 7.32398L4.8386 7.25598L4.9666 6.88398C5.43527 5.51665 6.59927 4.66732 8.0026 4.66732C9.8406 4.66732 11.3359 6.16265 11.3359 8.00065V8.66732H12.0026C12.7379 8.66732 13.3359 9.26532 13.3359 10.0007C13.3359 10.736 12.7379 11.334 12.0026 11.334H10.0026V12.6673H12.0026C13.4733 12.6673 14.6693 11.4713 14.6693 10.0007C14.6682 9.40306 14.467 8.82304 14.0977 8.3532C13.7284 7.88337 13.2124 7.55082 12.6319 7.40865C12.3406 5.11398 10.3759 3.33398 8.0026 3.33398C6.16527 3.33398 4.56927 4.40798 3.8406 6.10065C2.4086 6.52865 1.33594 7.88065 1.33594 9.33398C1.33594 11.172 2.83127 12.6673 4.66927 12.6673Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxCloudUpload);
export default __webpack_public_path__ + "static/media/bx-cloud-upload.dd25c6ba9e5a15a46d70528773b066c3.svg";
export { ForwardRef as ReactComponent };